import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import 'vue-toastification/dist/index.css'
import Clipboard from 'v-clipboard'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import App from '@/App.vue'

// Глобальные компоненты
import './global-components'

// Сторонние плагины
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'

// Сервисы и Axios
import AuthService from '@/core/auth/AuthService'
import ClickOutside from '@/core/directives/clickOutside'
import { isMetrikaEmbedding } from '@/helpers/isMetrikaEmbedding'
import axiosIns from '@/libs/axios'
import router from '@/router'
import store from '@/store'

import keycloakPlugin from './plugins/keycloak'
import yandexMetrika from './plugins/yandexMetrika'

import '@/assets/scss/_fonts.scss'

Vue.use(yandexMetrika)
Vue.use(keycloakPlugin)
Vue.use(ToastPlugin) // BootstrapVue Toast
Vue.use(ModalPlugin) // BootstrapVue Modal
Vue.directive('click-outside', ClickOutside)
Vue.use(VueCompositionAPI)
Vue.config.productionTip = false
Vue.use(Clipboard)
Vue.use(VueVirtualScroller)

function mountApp() {
    new Vue({
        router,
        store,
        render: h => h(App),
    }).$mount('#app')
}

// 3. Асинхронно инициализируем аутентификацию и запускаем приложение.
// Это самый важный шаг для избежания "гонки состояний".
AuthService.init(axiosIns)
    .then(authenticated => {
        if (authenticated) {
            // УСПЕХ: Пользователь аутентифицирован.
            // Только теперь мы можем безопасно создать и смонтировать приложение Vue.
            mountApp()
        } else {
            if (isMetrikaEmbedding()) {
                // Просмотр внутри Метрики: НЕ редиректим на Keycloak
                window.__READ_ONLY__ = true
                mountApp()
                return
            }
            // Обычный режим вне Метрики — принудительный логин
            const kc = AuthService.keycloak
            if (kc?.login) {
                kc.login()
            } else if (kc?.createLoginUrl) {
                window.location.href = kc.createLoginUrl()
            } else {
                console.warn('Keycloak instance is not ready to login.')
            }
        }
    })
    .catch(error => {
        // КРИТИЧЕСКАЯ ОШИБКА: Не удалось подключиться к серверу аутентификации.
        console.error(
            '☠️ Fatal Error: Failed to initialize authentication. App will not start.',
            error
        )
        // Показываем пользователю понятное сообщение об ошибке вместо белого экрана.
        document.getElementById('app').innerHTML = `
            <div style="text-align: center; padding: 50px; font-family: sans-serif; color: #333;">
                <h1>Ошибка аутентификации</h1>
                <p>Не удалось подключиться к сервису аутентификации. Пожалуйста, попробуйте перезагрузить страницу или свяжитесь с поддержкой.</p>
            </div>
        `
    })
